/**
 * Detects whether the current session is running inside a Median.co native app.
 *
 * Median's documented way to do this is the JS bridge (`Median.isNativeApp()`),
 * NOT user-agent sniffing — so this file simply re-exports the single shared
 * implementation used everywhere in the app.
 *
 * Usage:
 *   import { isMedianApp } from "@/lib/medianOneSignal";
 */
import { isMedianApp } from "./medianOneSignal";

export { isMedianApp };

// Also expose as a global for non-module scripts / quick checks in the console.
declare global {
  interface Window {
    isMedianApp: () => boolean;
  }
}

if (typeof window !== "undefined") {
  window.isMedianApp = isMedianApp;
}

export default isMedianApp;
